var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.img,"alt":_vm.iso},on:{"error":function($event){return _vm.test(false)},"load":function($event){return _vm.test(true)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }